function wm_clear_filters(event) {
    event.preventDefault();
    let parent = event.target.closest('[data-filter-clear]')
    let current_filter = parent.dataset.filterClear;
    let current_term = parent.dataset.filterClearTerm;
    let current_url = new URL(window.location.href);

    if (current_term) {
        let active_options = current_url.searchParams.get(current_filter);
        active_options = active_options.split(',');
        active_options = active_options.filter((item) => item != current_term);

        if (active_options.length) {
            current_url.searchParams.set(current_filter, active_options.join(','));
        } else {
            current_url.searchParams.delete(current_filter);
        }

        window.location.href = current_url;
        return;
    }

    if (current_filter) {
        current_url.searchParams.delete(current_filter);
    } else {
        current_url.searchParams.forEach((v, k) => current_url.searchParams.delete(k));
    }

    window.location.href = current_url;
}

{
    let filters = document.querySelectorAll('[data-filter-clear]');

    if (filters !== null) {
        for (let el of filters) {
            el.addEventListener('click', wm_clear_filters);
        }
    }
}
